/* Stitchi Studio · ss-cadeaus.js (fase D, bouwer A): cadeaugids (preview cadeaus.html), filter "voor wie" × budget zonder herladen.
   Kaarten, prijzen (centen) en tags komen uit de HTML (<template id="cg-pool">, sections/ss-home-cadeaus.liquid); teksten uit #cg-data.
   Logica 1-op-1 de preview: per ontvanger eerst de eigen-fotoproducten, dan (vriendin) drie mini-bundels, dan de ontwerpen met de
   meeste passende thema's (favorieten eerst); per budget de goedkoopste variant binnen het budget. Maximaal 12 kaarten. */
(function () {
  'use strict';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  var VOOR = {
    iedereen: { ef: ['eigen-foto-kleuren-op-nummer', 'eigen-foto-borduurpakket'], mini: false, th: [] },
    partner: { ef: ['eigen-foto-kleuren-op-nummer', 'eigen-foto-borduurpakket', 'eigen-foto-mozaiek'], mini: false, th: ['steden-reizen', 'landschap', 'kunst'] },
    ouders: { ef: ['eigen-foto-borduurpakket', 'eigen-foto-kussensloop-pakket', 'eigen-foto-kleuren-op-nummer'], mini: false, th: ['bloemen', 'huiselijk', 'landschap', 'seizoenen'] },
    vriendin: { ef: ['eigen-foto-kleuren-op-nummer'], mini: true, th: ['bloemen', 'steden-reizen'] },
    huisdier: { ef: ['eigen-foto-kleuren-op-nummer', 'eigen-foto-borduurpakket', 'eigen-foto-kussensloop-pakket'], mini: false, th: ['dieren'] }
  };
  /* thema's van de preview (SS.THEMES) → producttags in Shopify */
  var THEMA = {
    dieren: ['thema-dieren-huisdieren', 'kon-thema-dieren-huisdieren', 'hond', 'kat', 'huisdier'],
    bloemen: ['thema-bloemen-botanisch', 'kon-thema-bloemen-botanisch', 'collectie-rozen-bloementuinen'],
    'steden-reizen': ['thema-steden-straatjes', 'kon-thema-steden-straatjes', 'thema-reizen-avontuur', 'kon-thema-reizen-avontuur', 'thema-monumenten-wereldplekken'],
    landschap: ['thema-landschappen-natuur', 'kon-thema-landschappen-natuur'],
    seizoenen: ['thema-seizoenen-feestdagen'],
    kunst: ['oude-meester', 'kon-thema-oude-meesters'],
    huiselijk: ['thema-cottage-wonen', 'kon-thema-cottage-wonen']
  };
  var BUDGET = { alle: [0, 1e9], onder40: [0, 3999], '40-60': [4000, 6000], boven60: [6001, 1e9] };
  var BOUD = { '40-70': '40-60', boven70: 'boven60' }, OUD = { moeder: 'ouders', oma: 'ouders', kinderen: 'iedereen', jezelf: 'iedereen' };
  var BEST = ['eigen-foto-kleuren-op-nummer', 'eigen-foto-borduurpakket', 'kleuren-op-nummer-stadse-charme', 'kleuren-op-nummer-landelijke-droom', 'kleuren-op-nummer-zonsondergang-dromen', 'meisje-met-de-parel-johannes-vermeer-kleuren-op-nummer', 'kleuren-op-nummer-mediterranean-summer', 'kleuren-op-nummer-seizoensbloei'];
  var MAX = 12;

  function start() {
    var pool = $('#cg-pool'), data = $('#cg-data'); if (!pool || !data) return;
    var C = {}; try { C = JSON.parse(data.textContent); } catch (e) { return; }
    if (C.grens && C.grens.length === 2) { var g1 = +C.grens[0], g2 = +C.grens[1]; BUDGET.onder40 = [0, g1 - 1]; BUDGET['40-60'] = [g1, g2]; BUDGET.boven60 = [g2 + 1, 1e9]; }   /* grenzen in de valuta van de bezoeker (JPY) */
    var geld = function (c) { return window.SS && SS.geld ? SS.geld(c) : (c / 100).toFixed(2); };

    /* taalonafhankelijk (vertaalronde): handles zijn per taal vertaald (DE persoenliches-stickset); de eigen-fotoproducten
       daarom op tags terug naar hun Nederlandse handle, en Kleuren op Nummer ook op de tag kleuren-op-nummer */
    function canon(el) {
      var h = el.getAttribute('data-h'), t = el.getAttribute('data-t') || '';
      if (el.hasAttribute('data-ef')) {
        if (t.indexOf('|eigen-foto-kleurkunst|') > -1) return 'eigen-foto-kleuren-op-nummer';
        if (t.indexOf('|fotoborduren|') > -1) return 'eigen-foto-kussensloop-pakket';
        if (t.indexOf('|mozaiekkunst|') > -1) return 'eigen-foto-mozaiek';
        if (t.indexOf('|custom|') > -1) return 'eigen-foto-borduurpakket';
      }
      return h;
    }
    var P = $$('[data-h]', pool.content).map(function (el, i) {
      return { h: canon(el), ef: el.hasAttribute('data-ef'), el: el,
        p: el.getAttribute('data-p').trim().split(/\s+/).map(Number).filter(function (x) { return x > 0; }),
        t: el.getAttribute('data-t') || '', i: i };
    });
    var opH = {}, nK = 0, nA = 0;
    P.forEach(function (p) { opH[p.h] = p; p.r = p.el.hasAttribute('data-kon') || p.t.indexOf('|kleuren-op-nummer|') > -1 ? (nK++) * 2 : (nA++) * 2 + 1; });
    /* favorieten eerst (preview SS.BEST), daarna om en om Kleuren op Nummer en kruissteek in de volgorde van de collecties */
    function rang(p) { var b = BEST.indexOf(p.h); return b > -1 ? b : 100 + p.r; }
    function heeft(p, tag) { return p.t.indexOf('|' + tag + '|') > -1; }
    function score(p, voor) {
      var r = VOOR[voor], s = heeft(p, 'cadeau-' + voor) ? 10 : 0;
      r.th.forEach(function (t) { if (THEMA[t].some(function (tag) { return heeft(p, tag); })) s++; });
      return s;
    }

    var u = new URLSearchParams(location.search), qv = OUD[u.get('voor')] || u.get('voor'), qb = BOUD[u.get('budget')] || u.get('budget');
    var st = { voor: VOOR[qv] ? qv : 'iedereen', budget: BUDGET[qb] ? qb : 'alle' };

    function kies() {
      var r = VOOR[st.voor], b = BUDGET[st.budget], uit = [], gezien = {};
      function neem(p) {
        if (!p || gezien[p.h]) return;
        var in_ = p.p.filter(function (x) { return x >= b[0] && x <= b[1]; }); if (!in_.length) return;
        gezien[p.h] = 1; uit.push({ p: p, min: Math.min.apply(null, in_), varieert: in_.some(function (x) { return x !== in_[0]; }) });
      }
      r.ef.forEach(function (h) { neem(opH[h]); });
      if (r.mini) P.filter(function (p) { return heeft(p, 'mini-bundel') || heeft(p, 'mini'); }).sort(function (a, c) { return rang(a) - rang(c); }).slice(0, 3).forEach(neem);
      var lijst = r.th.length ? P.filter(function (p) { return !p.ef && score(p, st.voor) > 0; }) : P.filter(function (p) { return !p.ef; });
      lijst.sort(function (a, c) { return score(c, st.voor) - score(a, st.voor) || rang(a) - rang(c); }).forEach(neem);
      return uit;
    }

    function render() {
      $$('#f-voor [data-voor]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-voor') === st.voor ? 'true' : 'false'); });
      $$('#f-budget [data-budget]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-budget') === st.budget ? 'true' : 'false'); });
      var r = C.voor[st.voor] || {}, l = kies();
      $('#res-titel').textContent = r.titel + (st.budget !== 'alle' ? ' · ' + String(C.budget[st.budget] || '').toLowerCase() : '');
      $('#res-uitleg').textContent = l.length ? r.uitleg + ' ' + l.length + ' ' + (l.length === 1 ? C.een : C.meer) + (st.budget !== 'alle' ? C.budgetNoot : '.') : '';
      $$('#res-tip [data-tip]').forEach(function (x) { x.hidden = !(l.length && x.getAttribute('data-tip') === st.voor); });
      var grid = $('#res'); grid.innerHTML = '';
      l.slice(0, MAX).forEach(function (x) {
        var k = x.p.el.querySelector('.kaart').cloneNode(true), pr = k.querySelector('.prijs');
        if (pr) pr.textContent = (x.varieert && document.documentElement.lang.slice(0, 2) !== 'ja' ? C.vanaf + ' ' : '') + geld(x.min) + (x.varieert && document.documentElement.lang.slice(0, 2) === 'ja' ? C.vanaf : '');   /* ja: "¥10,000から" */
        grid.appendChild(k);
      });
      var meer = $('#res-meer'); if (meer && r.meer) meer.href = r.meer;
      $('#res-leeg').hidden = !!l.length;
      var q = new URLSearchParams(location.search);
      if (st.voor !== 'iedereen') q.set('voor', st.voor); else q.delete('voor');
      if (st.budget !== 'alle') q.set('budget', st.budget); else q.delete('budget');
      try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var v = e.target.closest && e.target.closest('[data-voor]'), bu = e.target.closest && e.target.closest('[data-budget]');
      if (v) { st.voor = v.getAttribute('data-voor'); render(); }
      if (bu) { st.budget = bu.getAttribute('data-budget'); render(); var g = $('#f-budget [data-budget="' + st.budget + '"]'); if (g && !bu.closest('#f-budget')) g.focus(); }
    });
    render();

    /* deadline en planning: datums uit SS.DEADLINES (ss-core.js, zelfde formule als de levertijd; indicatie) */
    var S = window.SS || {}, D = S.DEADLINES || {};
    var dl = $('#cg-deadline'); if (dl) { var h = S.deadlineRegelHTML ? S.deadlineRegelHTML(true, 'cg-dl') : ''; dl.innerHTML = h; dl.hidden = !h; }
    var lang = function (d) { return d ? (S.datumLang ? S.datumLang(d) : d.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' })) : ''; };   /* taal van de bezoeker (ss-core.js SS.datumLocale); NL gelijk */
    var nu = new Date(), vandaag = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), 12), esc = S.esc || function (s) { return s; }, PL = C.plan || {};
    var bonA = function (t) { return C.bon ? '<a class="link" href="' + esc(C.bon) + '">' + esc(t) + '</a>' : ''; };
    function kaart(naam, d) {
      var voorbij = d && vandaag > d;
      return '<div class="' + (voorbij ? 'voorbij' : '') + '"><span class="cg-feest">' + esc(naam) + '</span><b>' + (voorbij ? esc(PL.teLaat) : esc(PL.uiterlijk.replace('%D%', lang(d)))) + '</b><span>' + (voorbij ? (C.bon ? esc(PL.teLaatBon) : '') : esc(PL.opTijd)) + '</span></div>';
    }
    var pl = $('#cg-planning');
    if (pl) pl.innerHTML = (D.sinterklaas ? kaart(PL.sint, D.sinterklaas) : '') + (D.kerst ? kaart(PL.kerst, D.kerst) : '') +
      (C.bon ? '<div><span class="cg-feest">' + esc(PL.daarna) + '</span><b>' + esc(PL.bonT) + '</b><span>' + esc(PL.bonTekst) + ' ' + bonA(PL.bonLink) + '</span></div>' : '');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
